// extracted by mini-css-extract-plugin
export var aircallIframe = "_hv-3";
export var fabContainer = "_hv-5";
export var fabRinging = "_hv-6";
export var loadingOverlay = "_hv-4";
export var pulse = "_hv-7";
export var widgetContent = "_hv-2";
export var widgetPanel = "_hv-0";
export var widgetPanelExpanded = "_hv-1";